var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-group-ui"},[_vm._t("alert",null,{"alert":_vm.alert}),_vm._t("triggers",null,{"active":_vm.active,"handleSelected":_vm.handleSelected}),_vm._t("content",null,{"active":_vm.active})],2)}
var staticRenderFns = []

export { render, staticRenderFns }